import { Component, ViewChild, OnInit, OnDestroy, Input, EventEmitter, Output, Injector } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { Store } from '@ngrx/store';
import { PermissionSetService, PermissionSetAssigneeTargetService } from 'blg-akaun-ts-lib';
import { PermissionFacade } from '../../../../../../../../../../modules/permission/facades/permission.facade';
import { gridOptionsClientSide } from '../../../../../../../../../../listing.utils';
import { PaginationComponent } from '../../../../../../../../../../utilities/pagination/pagination.component';
import { ViewColumnComponent } from '../../../../../../../../../../view-column.component';
import { AppConfig } from '../../../../../../../../../../visa';
import { SubSink } from 'subsink2';
import { PermissionStates } from '../../../../../../../../permission-controller/root';
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: 'app-permission-set-line',
    templateUrl: './permission-set-line.component.html',
    styleUrls: ['./permission-set-line.component.scss']
})

export class PermissionSetLineComponent extends ViewColumnComponent implements OnInit, OnDestroy {

    @ViewChild(MatTabGroup, {static:true}) matTab: MatTabGroup;

    @ViewChild(PaginationComponent, {static: false})
    private paginationComponent: PaginationComponent;

    @Input() localState: any;
    @Input() permSetLine: any;
    @Output() permSetLineEntity = new EventEmitter();

    // api visa
    apiVisa = AppConfig.apiVisa;

    // initial ag grid state
    gridApi;
    gridOptions = gridOptionsClientSide;
    columnsDefs;
    rowSelection = 'single';
    rowData;

    roleGuid: string;

    // subSink is to ensure all subscribe calls are unsubscribed to once the component is destroyed
    private subSink = new SubSink;

    appletGuid = sessionStorage.getItem('appletGuid');

    //translation variable
    permission_set_code_text: string;
    permission_set_name_text: string;
    permission_set_target_text: string;

    constructor(
        // private fb: FormBuilder,
        private store: Store<PermissionStates>,
        private viewColFacade: PermissionFacade,
        // private readonly componentStore: ComponentStore<{localState: LocalState}>,
        private permissionSetService: PermissionSetService,
        private permissionSetAssigneeTargetService: PermissionSetAssigneeTargetService,
        private injector: Injector
      ) {
        super();
        const translateService = this.injector.get(TranslateService, null);
        if (translateService) {
          translateService.get('labels').subscribe(res => {
            this.permission_set_code_text = res.permission_set_code;
            this.permission_set_name_text = res.permission_set_name;
            this.permission_set_target_text = res.permission_set_target;
          });
        } else {
          // Fallback if translation service is unavailable
          this.permission_set_code_text = 'Permission Set Code';
          this.permission_set_name_text = 'Permission Set Name';
          this.permission_set_target_text = 'Permission Set Target';
        }
      }

    /**
     * Lifecycle method: Called when component is first initialised.
     */
    ngOnInit(): void {

        this.columnsDefs = [
            {
                headerName: this.permission_set_code_text,
                field: 'code',
                cellStyle: {textAlign: 'left'}
            },
            {
                headerName: this.permission_set_name_text,
                field: 'name',
                cellStyle: {textAlign: 'left'}
            },
            {
                headerName: this.permission_set_target_text,
                field: 'target_hdr_table',
                cellStyle: {textAlign: 'left'}
            }
        ]
    }

    /**
     * This function is called when AG grid is first initialised and initially
     * set the datasource of the grid.
     *
     * @param params : grid parameters
     */
    onGridReady(params) {
        this.gridApi = params.api;
        this.gridApi.closeToolPanel();
        this.gridApi.setRowData(this.permSetLine);
    }

  /**
   * This function is called every time the user clicks on a row in the
   * AG grid.
   *
   * @param entity : the entity on the AG grid that was clicked on
   */
  onRowClicked(entity) {
    this.permSetLineEntity.emit(entity);
  }


  /**
   * Lifecycle method: Called when component is destroyed.
   */
  ngOnDestroy() {
    this.subSink.unsubscribe();
  }

}
